import QuestionDescription from './QuestionDescription';

export default QuestionDescription;
